import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import ErrorBoundary from "components/Library/ErrorBoundary";
import SkipToContentLink from "../SkipToContentLink";

import styles from "./NavigationWrapper.css";

export default function NavigationWrapper(props) {
  return (
    <ErrorBoundary>
      <div className={classNames(styles.root)}>
        <SkipToContentLink href="#main" className={styles.changeNav} />
        <nav
          role="navigation"
          className={classNames(styles.navbar, props.className)}
        >
          {props.children}
        </nav>
      </div>
    </ErrorBoundary>
  );
}

NavigationWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};
